'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Icon } from '@udemy-v2/icons';
import { BlockListItem, BlockListProps, Button, IconButton } from '@udemy-v2/react-core-components';
import { Duration, useI18n } from '@udemy-v2/i18n';
import classNames from 'classnames';
import { Lecture as LectureType } from '@udemy-v2/browse-course';
import { curriculumItemIcon } from './curriculumItemIcon';
import { CoursePreviewModal } from '../course-preview/course-preview-modal.react-component';
import styles from './curriculum-section.module.scss';
export interface CurriculumLecture extends LectureType {
  aiSummary?: string;
  contentSummary?: string;
}
export interface LectureComponentProps {
  lecture: CurriculumLecture;
  showSectionContentsText?: boolean;
}
export const Lecture = t0 => {
  const $ = _c(48);
  const {
    lecture,
    showSectionContentsText: t1
  } = t0;
  const showSectionContentsText = t1 === undefined ? false : t1;
  const {
    gettext
  } = useI18n();
  const [showDescription, setShowDescription] = useState(false);
  const [showModal, setShowModal] = useState(false);
  let t2;
  if ($[0] !== lecture.aiSummary || $[1] !== lecture.description) {
    t2 = lecture.description?.trim() ? <span dangerouslySetInnerHTML={{
      __html: lecture.description
    }} /> : lecture.aiSummary?.trim() ? <p>{lecture.aiSummary}</p> : null;
    $[0] = lecture.aiSummary;
    $[1] = lecture.description;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const descriptionContent = t2;
  let t3;
  if ($[3] !== lecture.type) {
    t3 = curriculumItemIcon(lecture.type);
    $[3] = lecture.type;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Icon color="neutral" glyph={t3} label={false} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const LectureIcon = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      size: "small"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const blockListItemProps = t5;
  let t6;
  if ($[8] !== showDescription) {
    t6 = event => {
      setShowDescription(!showDescription);
      event.stopPropagation();
    };
    $[8] = showDescription;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const toggleDescription = t6;
  let t7;
  if ($[10] !== gettext || $[11] !== showDescription) {
    t7 = showDescription ? <Icon color="neutral" glyph="collapse" label={gettext("Hide lecture description")} /> : <Icon color="neutral" glyph="expand" label={gettext("Show lecture description")} />;
    $[10] = gettext;
    $[11] = showDescription;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const ToggleDescriptionIcon = t7;
  const shouldShowPreviewLink = lecture.isPreviewable && showSectionContentsText && lecture.durationInSeconds;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setShowModal(true);
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const handleOpenModal = t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setShowModal(false);
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const handleCloseModal = t9;
  let t10;
  if ($[15] !== lecture.title) {
    t10 = <span className={styles["course-lecture-title"]}>{lecture.title}</span>;
    $[15] = lecture.title;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const title = t10;
  let t11;
  if ($[17] !== ToggleDescriptionIcon || $[18] !== descriptionContent || $[19] !== showDescription || $[20] !== toggleDescription) {
    t11 = descriptionContent && <IconButton onClick={toggleDescription} round={true} size="small" className={classNames(styles["hidden-on-mobile"], styles["toggle-item-description-button"])} udStyle="ghost" aria-expanded={showDescription} data-testid="toggle-description-button">{ToggleDescriptionIcon}</IconButton>;
    $[17] = ToggleDescriptionIcon;
    $[18] = descriptionContent;
    $[19] = showDescription;
    $[20] = toggleDescription;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className={styles["hidden-on-mobile"]} style={{
      flex: 1
    }} />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== gettext || $[24] !== shouldShowPreviewLink) {
    t13 = shouldShowPreviewLink && <><Button udStyle="link-underline" typography="ud-text-sm" onClick={handleOpenModal}><span className={classNames(styles["preview-text"])}><Icon glyph="play" label={false} color="neutral" className={styles.icon} />{gettext("Preview")}</span></Button></>;
    $[23] = gettext;
    $[24] = shouldShowPreviewLink;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== lecture.durationInSeconds) {
    t14 = lecture.durationInSeconds ? <span className={classNames(styles["hidden-on-mobile"], styles["item-content-summary"])}><Duration numSeconds={lecture.durationInSeconds} precision="seconds" presentationStyle="timestamp" /></span> : null;
    $[26] = lecture.durationInSeconds;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t14 || $[31] !== title) {
    t15 = <div className={styles.row}>{title}{t11}{t12}{t13}{t14}</div>;
    $[28] = t11;
    $[29] = t13;
    $[30] = t14;
    $[31] = title;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== descriptionContent || $[34] !== showDescription) {
    t16 = descriptionContent && <div className={classNames(styles["hidden-on-mobile"], styles["item-description"], "ud-text-sm", {
      [styles.collapsed]: !showDescription
    })} data-testid="lecture-description">{descriptionContent}</div>;
    $[33] = descriptionContent;
    $[34] = showDescription;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <div>{t15}{t16}</div>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== LectureIcon || $[40] !== t17) {
    t18 = <BlockListItem icon={LectureIcon} {...blockListItemProps} color="neutral">{t17}</BlockListItem>;
    $[39] = LectureIcon;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== lecture.id || $[43] !== showModal) {
    t19 = <CoursePreviewModal isOpen={showModal} onClose={handleCloseModal} uiRegion="curriculum" selectedLectureId={lecture.id} />;
    $[42] = lecture.id;
    $[43] = showModal;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t18 || $[46] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[45] = t18;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  return t20;
};